import { useEffect, useState } from 'react';
import {
  Container,
  TableContainer,
  Table,
  TableCell,
  TableHead,
  TableRow,
  TableBody,
  Card,
  Paper,
  Button,
  Backdrop,
  CircularProgress,
  Stack,
  Typography,
  Skeleton
} from '@mui/material';
import { Delete, Edit } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

import { getEmployees, deleteEmployee } from '../utils/requests/employeesRequest';
import QuestionDialog from '../components/QuestionDialog';

export default function Employees() {
  const [employees, setEmployees] = useState(undefined);
  const [id, setId] = useState(-1);
  const [deleteItem, setDeleteItem] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  useEffect(() => loadEmployees(), []);

  const loadEmployees = () => {
    getEmployees().then((employees) => {
      setEmployees(employees);
    });
  };

  const onDelete = (id) => {
    setDeleteItem(true);
    setId(id);
  };

  const onOkClick = () => {
    setIsLoading(true);
    setDeleteItem(false);
    deleteEmployee(id).then((response) => {
      toast.success(response.data.message);
      setIsLoading(false);
      loadEmployees();
    });
  };

  const cancel = () => {
    setDeleteItem(false);
  };

  return (
    <Container>
      <Stack direction="row" justifyContent="flex-start" alignItems="flex-start" spacing={2}>
        <Typography variant="h4" sx={{ mb: 5 }}>
          Employees
        </Typography>
        <Button onClick={() => navigate('./add')}>Add new employee</Button>
        <Button onClick={() => navigate('./move')}>Reorder employees</Button>
      </Stack>
      <QuestionDialog
        buttons={[
          { action: () => onOkClick(), text: 'Yes' },
          { action: () => cancel(), text: 'Cancel' }
        ]}
        onClose={() => cancel()}
        title="Are your sure to delete ?"
        text="There is no way to recover deleted data !"
        isOpen={deleteItem}
      />
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={isLoading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Card>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell>ID</TableCell>
                <TableCell align="left">Photo</TableCell>
                <TableCell align="left">Name</TableCell>
                <TableCell align="left">Role</TableCell>
                <TableCell align="center">Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {!employees && (
                <TableRow
                  key="not-loaded"
                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                >
                  <TableCell component="th" scope="row">
                    <Skeleton variant="circular" width={25} height={25} />
                  </TableCell>
                  <TableCell align="left">
                    <Skeleton variant="circular" width={50} height={50} />
                  </TableCell>
                  <TableCell align="left">
                    <Skeleton variant="text" />
                  </TableCell>
                  <TableCell align="left">
                    <Skeleton variant="text" />
                  </TableCell>
                  <TableCell align="left">
                    <Stack direction="row" spacing={2}>
                      <Skeleton variant="circular" width={25} height={25} />
                      <Skeleton variant="circular" width={25} height={25} />
                    </Stack>
                  </TableCell>
                </TableRow>
              )}
              {employees &&
                employees.map((employee) => (
                  <TableRow
                    key={employee.id}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                  >
                    <TableCell component="th" scope="row">
                      {employee.id}
                    </TableCell>
                    <TableCell align="left">
                      <img src={employee.photo} alt="couldn't load" style={{ width: 50 }} />
                    </TableCell>
                    <TableCell align="left">{employee.name}</TableCell>
                    <TableCell align="left">
                      <Button onClick={() => onDelete(employee.id)}>
                        <Delete />
                      </Button>
                      <Button onClick={() => navigate(`./${employee.id}`)}>
                        <Edit />
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Card>
    </Container>
  );
}
